// import React from "react";
// import { useSelector } from "react-redux";

// export const APP_API_URL = "http://127.0.0.1:8000/api";
// export const APP_URL = "http://127.0.0.1:8000";

// export const APP_API_URL = "https://api.asebat.com/api";
// export const APP_URL = "https://api.asebat.com";

export const APP_API_URL = "https://pos-srv.asebatsarl.com/api";
export const APP_URL = "https://pos-srv.asebatsarl.com";

export const APP_NAME = "ASEBât";

// const user = useSelector((state) => state.auth.user);
// const isRole13 = Number(user?.personnels?.[0]?.poste_id) === 13;

export const SIDEBAR_LINKS = [
  {
    id: 1,
    icon: "bi bi-cash-stack",
    text: "Caisse",
    url: "/",
    category: "Gestion des ventes"
  },
  // {
  //   id: 2,
  //   icon: "bi bi-check-circle",
  //   text: "Validations",
  //   url: "/validations",
  //   category: "Gestion des ventes"
  // },
  {
    id: 3,
    icon: "bi bi-people",
    text: "Clients",
    url: "/clients",
    category: "Gestion des ventes"
  },
  {
    id: 4,
    icon: "bi bi-cart-check",
    text: "Ventes",
    url: "/commandes",
    category: "Gestion des commandes"
  },
  {
    id: 5,
    icon: "bi bi-box-seam",
    text: "Approvisionnement",
    url: "/approvisionnement",
    category: "Gestion des commandes"
  },
  {
    id: 6,
    icon: "bi bi-box",
    text: "Produits",
    url: "/articles",
    category: "Gestion des produits"
  },
  // ...(!isRole13 ? [{
  //   id: 12,
  //   icon: "bi bi-plus-circle",
  //   text: "Créer un produit",
  //   url: "/add-product",
  //   category: "Gestion des produits"
  // }] : []),
  {
    id: 13,
    icon: "bi bi-tag",
    text: "Catégories",
    url: "/categories",
    category: "Gestion des produits"
  },
  {
    id: 14,
    icon: "bi bi-tags",
    text: "Sous-catégorie",
    url: "/sub-categories",
    category: "Gestion des produits"
  },
  {
    id: 17,
    icon: "bi bi-tags",
    text: "Marques",
    url: "/marques",
    category: "Gestion des produits"
  },
  {
    id: 15,
    icon: "bi bi-archive",
    text: "Unités",
    url: "/units",
    category: "Gestion des produits"
  },
  {
    id: 7,
    icon: "bi bi-truck",
    text: "Fournisseurs",
    url: "/fournisseurs",
    category: "Gestion des produits"
  },
  {
    id: 8,
    icon: "bi bi-bar-chart",
    text: "Rapports",
    url: "/rapports",
    category: "Analytique"
  },
  {
    id: 18,
    icon: "bi bi-cash-coin",
    text: "Finance et Impôts",
    url: "/finance-impots",
    category: "Analytique"
  },
  {
    id: 9,
    icon: "bi bi-person-badge",
    text: "Personnel",
    url: "/personnel",
    category: "Ressources humaines"
  },
  {
    id: 32,
    icon: "bi bi-wallet2",
    text: "Paie du mois",
    url: "/personnel/paie",
    category: "Ressources humaines"
  },
  {
    id: 33,
    icon: "bi bi-pen",
    text: "Signature et cachet",
    url: "/personnel/paie/reglages",
    category: "Ressources humaines"
  },
  {
    id: 16,
    icon: "bi bi-person-badge",
    text: "Postes",
    url: "/roles-permissions",
    category: "Ressources humaines"
  },
  {
    id: 15,
    icon: "bi bi-shop",
    text: "Showroom",
    url: "/stores",
    category: "Administration"
  },
  {
    id: 10,
    icon: "bi bi-building",
    text: "Magasins",
    url: "/warehouses",
    category: "Administration"
  },
  {
    id: 18,
    icon: "bi bi-archive",
    text: "Formats",
    url: "/formats",
    category: "Gestion des produits"
  },
  {
    id: 19,
    icon: "bi bi-archive",
    text: "Liste des Ventes",
    url: "/admin/ventes",
    category: "Gestion des ventes"
  },
  {
    id: 21,
    icon: "bi bi-archive",
    text: "Résumé des Produits",
    url: "/admin/summary",
    category: "Gestion des produits"
  },
  {
    id: 22,
    icon: "bi bi-archive",
    text: "Inventaire",
    url: "/admin/stock-adjustments",
    category: "Gestion des produits"
  },
  {
    id: 23,
    icon: "bi bi-archive",
    text: "Liste des ventes non terminées",
    url: "/admin/installment-orders",
    category: "Gestion des commandes"
  },
  {
    id: 24,
    icon: "bi bi-box",
    text: "Carraux cassé",
    url: "/admin/broken-tiles",
    category: "Gestion des produits"
  },
  {
    id: 25,
    icon: "bi bi-box",
    text: "Stock disponible",
    url: "/stock-available",
    category: "Administration"
  },
  // Rapports commerciaux (/business-reports) — menu déplacé côté admin plus tard ; route conservée dans App.js
  {
    id: 27,
    icon: "bi bi-box",
    text: "Produits les plus achetés",
    url: "/best-selling",
    category: "Analytique"
  },
  {
    id: 28,
    icon: "bi bi-box",
    text: "Vente Carraux cassé",
    url: "/admin/sales-broken-tiles/list",
    category: "Gestion des produits"
  },
  {
    id: 29,
    icon: "bi bi-bandaid",
    text: "Articles cassés / gâtés",
    url: "/admin/damaged-goods",
    category: "Gestion des produits"
  },
  {
    id: 30,
    icon: "bi bi-bandaid",
    text: "Vente articles cassés",
    url: "/admin/damaged-goods/sales/list",
    category: "Gestion des produits"
  },
  {
    id: 31,
    icon: "bi bi-gift",
    text: "Dons",
    url: "/admin/dons",
    category: "Gestion des produits"
  },
  {
    id: 40,
    icon: "bi bi-house-door-fill",
    text: "Tableau de bord",
    url: "/comptable",
    category: "Comptabilité"
  },
  {
    id: 41,
    icon: "bi bi-box-seam",
    text: "Gestion des stocks",
    url: "/inventory",
    category: "Comptabilité"
  },
  {
    id: 42,
    icon: "bi bi-cart-check",
    text: "Gestion des ventes",
    url: "/sales",
    category: "Comptabilité"
  },
  {
    id: 34,
    icon: "bi bi-box-seam",
    text: "Livraisons à valider",
    url: "/livraisons",
    category: "Magasin"
  },
  {
    id: 35,
    icon: "bi bi-clock-history",
    text: "Historique des livraisons",
    url: "/commandes/history",
    category: "Magasin"
  },
  {
    id: 36,
    icon: "bi bi-bar-chart",
    text: "Quantités avant / après",
    url: "/summary",
    category: "Magasin"
  },
  {
    id: 37,
    icon: "bi bi-check-circle",
    text: "Validation des commandes",
    url: "/commandes/validation",
    category: "Magasin"
  },
];